import { getData } from '@ricoh/ria.client.core/plugins/swr/common';
import { createFetcher } from '@ricoh/ria.client.core/plugins/swr/fetcher';
import axios from 'axios';

import type { CSRFTokenResponse } from './_fetcher.type';

import requestConfig from './_request';

const { options, endpoints, createError } = requestConfig;

// * Use basic axios instance for anti-forgery token fetching.
const client = axios.create(options);

/** Get CSRFToken fetcher. */
export const getCSRFTokenFetcher = createFetcher<void, CSRFTokenResponse>(endpoints.getCSRFToken.key, async () => {
  try {
    return getData<CSRFTokenResponse>(await client.request(endpoints.getCSRFToken()));
  } catch (exception) {
    throw createError('getCSRFToken', 'Failed to get CSRF token.', exception);
  }
});
